import { render } from "./ClientesComponent.vue?vue&type=template&id=797df765"
import script from "./ClientesComponent.vue?vue&type=script&lang=js"
export * from "./ClientesComponent.vue?vue&type=script&lang=js"

import "./ClientesComponent.vue?vue&type=style&index=0&id=797df765&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__